import { render, staticRenderFns } from "./TopGroupsByContacts.vue?vue&type=template&id=354ff3b1&"
import script from "./TopGroupsByContacts.vue?vue&type=script&lang=js&"
export * from "./TopGroupsByContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports